import type React from 'react';
import { Navbar, Footer } from '@shadeables/ui';
import styles from './AuthLayout.module.css';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
  return (
    <div className={styles.authPage}>
      <Navbar />
      <div className={styles.authContainer}>
        <div className={styles.formContainer}>
          <h2 className={styles.title}>{title}</h2>
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};
